import styled from "@emotion/styled";

export const StyledOrderDetailsShipmentHeaderContainer = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
	gap: theme.spacing(2),
	[theme.breakpoints.down("lg")]: {
		display: "flex",
		flexDirection: "column",
		gap: "8px"
	},
	div: {
		display: "flex",
		alignItems: "center",
		gap: "4px",
		span: {
			color: theme.project.colors.fontColors.secondary,
			"&:first-child": {
				...theme.project.typography.subtitle.subtitle2,
				lineHeight: "20px"
			},
			"&:nth-child(2)": {
				...theme.project.typography.body.body2
			}
		}
	}
}));
